import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card } from "@/components/ui/card";
import { Filter } from "lucide-react";

interface RecordFiltersProps {
  filters: {
    type: string;
    risk: string;
    dateRange: string;
    hasDocument: string;
  };
  onFiltersChange: (filters: any) => void;
}

export function RecordFilters({ filters, onFiltersChange }: RecordFiltersProps) {
  return (
    <Card className="p-4">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
          <Filter className="h-4 w-4" />
          <span>Filtros:</span>
        </div>

        <Select
          value={filters.type}
          onValueChange={(value) => onFiltersChange({ ...filters, type: value })}
        >
          <SelectTrigger className="w-[180px] h-9">
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os tipos</SelectItem>
            <SelectItem value="anamnesis">Anamnese</SelectItem>
            <SelectItem value="clinical_note">Nota Clínica</SelectItem>
            <SelectItem value="vitals">Sinais Vitais</SelectItem>
            <SelectItem value="body_measurement">Antropometria</SelectItem>
            <SelectItem value="lab_exam">Exame Laboratorial</SelectItem>
            <SelectItem value="training_plan">Treino</SelectItem>
            <SelectItem value="nutritional_assessment">Nutricional</SelectItem>
            <SelectItem value="physiotherapy_evolution">Fisioterapia</SelectItem>
            <SelectItem value="aesthetic_protocol">Estético</SelectItem>
            <SelectItem value="chiropractic_adjustment">Quiropraxia</SelectItem>
            <SelectItem value="psychotherapy_session">Psicoterapia</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={filters.risk}
          onValueChange={(value) => onFiltersChange({ ...filters, risk: value })}
        >
          <SelectTrigger className="w-[160px] h-9">
            <SelectValue placeholder="Risco" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos os níveis</SelectItem>
            <SelectItem value="critical">Alto</SelectItem>
            <SelectItem value="warn">Moderado</SelectItem>
            <SelectItem value="info">Normal</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={filters.dateRange}
          onValueChange={(value) => onFiltersChange({ ...filters, dateRange: value })}
        >
          <SelectTrigger className="w-[160px] h-9">
            <SelectValue placeholder="Período" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todo período</SelectItem>
            <SelectItem value="7days">Últimos 7 dias</SelectItem>
            <SelectItem value="30days">Últimos 30 dias</SelectItem>
            <SelectItem value="90days">Últimos 90 dias</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={filters.hasDocument}
          onValueChange={(value) => onFiltersChange({ ...filters, hasDocument: value })}
        >
          <SelectTrigger className="w-[180px] h-9">
            <SelectValue placeholder="Documento" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="with">Com documento</SelectItem>
            <SelectItem value="without">Sem documento</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </Card>
  );
}
